<template>
	<div class="topTitle">
		<h1 class="title" @click="titleClick">
			{{ topTitleInfoFun(topTitleInfo.title) }}
			<img src="@/assets/svg/Arrow.svg" ref="Arrow" v-if="topTitleInfo.Info"/>
		</h1>
		<transition name="topintroduce">
			<div :class="['topintroduce',topTitleInfo.Info?'' : 'topintroduce1']" @click="titleClick" v-if="topintroduceState">{{ topTitleInfo.Info }}</div>
		</transition>
	</div>
</template>

<script>
export default{
	data(){
		return {
			topintroduceState: 1,
			menuIndex: this.$store.state.menuIndex, // 当前板块索引
			start: 0,
		}
	},
	props: ["topTitleInfo"],
	mounted(){
		if(this.menuIndex !=2 && this.menuIndex != 3){
			this.topintroduceState = 1;
			// setTimeout(() => {
			// 	this.titleClick();
			// 	this.start = 1;
			// },100);
			// setTimeout(() => {
			// 	this.titleClick();
			// 	// this.start = 0;
			// },1600);
		}
		
	},
	methods:{
		topTitleInfoFun(title){
			if(title.split("<br>").length > 1){
				return title.split("<br>")[0] + title.split("<br>")[1];
			}else{
				return title;
			}
		},
	
		titleClick(){
			if(!this.topTitleInfo.Info){
				return;
			}
			this.topintroduceState = !this.topintroduceState;
			if (this.topintroduceState) {
				this.$refs.Arrow.style.transform = "rotate(180deg)";
			} else {
				this.$refs.Arrow.style.transform = "rotate(0deg)";
			}
		},
	},
	computed: {
		activedPanoId(){
			return this.$store.state.activedPanoId;
		}
	},
	watch: {
        topTitleInfo(nv){
            console.log("*************************");
            console.log(nv);
            console.log("*************************");
        },
		activedPanoId(nv,ov){
			console.log("activedPanoId发生了变化，新的值是   " + nv);
			this.topintroduceState = 1;
			// if(this.start){
			// 	return;
			// }
			// setTimeout(() => {
			// 	this.titleClick();
			// },200);
			
		},
	}
}
</script>

<style lang="scss" scoped>
.topintroduce-enter {
	top: -2.43rem !important;
	opacity: 0;
}
// 控制元素显示过程中实现的具体动画效果
.topintroduce-enter-active {
	transition: all 0.5s ease;
}
// 控制元素完全显示之后的状态(样式、位移信息)
.topintroduce-enter-to {
	top: -0rem !important;
	opacity: 1 !important;
}

// 元素从显示到隐藏

// 控制元素隐藏之前的状态(样式、位移信息)
.topintroduce-leave {
	top: -0rem !important;
	opacity: 1 !important;
}
// 控制元素隐藏过程中实现的具体动画效果
.topintroduce-leave-active {
	transition: all 0.5s ease;
}
// 控制元素完全隐藏之后的状态(样式、位移信息)
.topintroduce-leave-to {
	top: -2.43rem !important;
	opacity: 0;
}
.topTitle{
	.title{
		width: auto;
		height: auto;
		color: #fff;
		font-size: 0.34rem;
		color: #fff;
		position: absolute;
		left: 50%;
		top: .3rem;
		transform: translateX(-50%);
		z-index: 1001;
		display: flex;
		align-items: center;
		img {
			width: 0.16rem;
			height: 0.14rem;
			margin-left: 0.1rem;
			transform: rotate(180deg);
			transition: all 0.5s ease;
		}
	}
	.topintroduce{
		width: 100%;
		height: auto;
		background: rgba(0, 0, 0, 0.35);
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1000;
		padding: 0.8rem 0.36rem 0.5rem 0.36rem;
		color: #fff;
        font-size: 0.26rem;
        line-height: 0.39rem;
        text-indent: 2em;
		&.topintroduce1{
			padding: 0
		}
	}
}
</style>
